import React, { useEffect, useRef } from 'react'
import CSSModules from 'react-css-modules'

// components
import { Touchable } from '@/components'
import queryString from 'query-string'
// util
import { evokeByTagA, checkOpen } from './evoke'
import { sniff, sensors } from '@/util'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
// 样式
import style from './LaunchApp.module.scss'

const delayTimeout = 2000

//  获取scheme地址
export const getSchemeLink = (url = '', schemeName = 'ubox', pageInfo = {}) => {
  let decodeUrl = decodeURIComponent(url)
  const isHttpUrl = /^http[s]?:/.test(decodeUrl)
  decodeUrl = /\?/.test(decodeUrl) ? `${decodeUrl}&fromapp=${sniff.type}` : `${decodeUrl}?fromapp=${sniff.type}`

  const jumpUrl = `${schemeName}:${isHttpUrl ? '//' : '/'}${decodeUrl}`

  // 增加神策埋点
  const sensorsPageInfoObj = {
    url_text: jumpUrl,
    page_title: document.title,
    souce_type: pageInfo?.souce_type || '',
    page_id: pageInfo?.page_id || 0,
  }
  let sensorsPageInfoStr = ''
  try {
    sensorsPageInfoStr = queryString.stringify(sensorsPageInfoObj)
  } catch (error) {
    console.log(error)
  }

  return `${jumpUrl}&pageInfo=${encodeURIComponent(sensorsPageInfoStr)}`
}

// 验证openUrl是否合法, url中有undefined就判定为不合法
// const verifyOpenUrl = url => !/=?(undefined|null)/g.test(url) && !!url

const LaunchApp = props => {
  const { children, fixed = true, blackSkin = true, extraClass = '', style = {}, openUrl = '', pageInfo = {}, sensorsKeyName = 'default', schemeName = 'ubox', launchError, onTap = null, ...otherProps } = props

  // const [launchShow, setLaunchShow] = useState(true)
  const launchBtnRef = useRef(null)

  // 跳转下载app地址
  const navigate = useNavigate()

  const pageInfoObj = { souce_type: pageInfo?.souce_type, page_id: pageInfo?.page_id }

  const goToDownload = () => {
    navigate(`/download-app?sensorsKeyName=${sensorsKeyName}DownloadClick`)
  }

  // 唤起失败
  const openAppFail = () => {
    if (!!launchError) {
      launchError && launchError()
    } else {
      goToDownload()
    }
  }

  // 微信内唤起成功
  const openAppSuccessInWechat = () => {
    sensors.track(`${sensorsKeyName}LaunchClick`)
  }

  // 微信使用微信开放API，非微信使用scheme打开
  const openAppNotInWechat = () => {
    if (sniff.isUboxApp) return
    sensors.track(`${sensorsKeyName}LaunchClick`)
    evokeByTagA(getSchemeLink(openUrl, schemeName, pageInfoObj))
    // 2s之后如果未唤起则跳到下载页面
    checkOpen(() => {
      openAppFail()
    }, delayTimeout)
  }

  useEffect(() => {
    if (!sniff.isWechat) return
    const curLaunchBtnRef = launchBtnRef?.current || null
    // 唤起标签错误时
    document.addEventListener('WeixinOpenTagsError', function() {
      openAppFail()
    })
    // 微信未下载需要跳转下载页面
    curLaunchBtnRef && curLaunchBtnRef.addEventListener('error', openAppFail)
    // 微信唤起成功
    curLaunchBtnRef && curLaunchBtnRef.addEventListener('launch', openAppSuccessInWechat)
    return () => {
      // 卸载launch事件
      curLaunchBtnRef && curLaunchBtnRef.removeEventListener('launch', openAppSuccessInWechat)
      // 卸载error事件
      curLaunchBtnRef && curLaunchBtnRef.removeEventListener('error', openAppFail)
    }
  }, [])

  // 微信SDK初始化
  useEffect(() => {
    // setLaunchShow(verifyOpenUrl(openUrl))
  }, [openUrl])

  return (
    <Touchable
        onTap={() => {
        onTap && onTap()
      }}
    >
      <div className={extraClass}
          style={style}
          styleName={classNames('open-app', { 'open-app-fixed': fixed })}
          {...otherProps}>
        <div styleName="wrap">
          {children ? (
            children
          ) : (
            <div styleName={classNames('contain', { 'white-skin': !blackSkin })}>
              <div styleName="icon"></div>
              <div styleName="info">
                <p styleName="name">ubox</p>
                <p styleName="text">打开 APP 查看详情</p>
              </div>
              <div styleName="other">
                <div styleName="btn-status">立即打开</div>
              </div>
            </div>
          )}
          {sniff.isWechat ? (
            <wx-open-launch-app
                appid="wx15e0e811701e27e6"
                extinfo={getSchemeLink(openUrl, schemeName)}
                ref={launchBtnRef}
                style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
            >
              <script type="text/wxtag-template">
                <div
                    style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    opacity: 0,
                  }}
                ></div>
              </script>
            </wx-open-launch-app>
          ) : (
            <div
                onClick={() => {
                openAppNotInWechat()
              }}
            >
              <div styleName="link"></div>
            </div>
          )}
        </div>
      </div>
    </Touchable>
  )
}

export default CSSModules(LaunchApp, style, { allowMultiple: true })
